import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { UserService } from '../../services/user.service';
import { ReportService } from "../../services/report.service";
import { NotificationsService } from 'angular2-notifications';
import { TransactionService } from '../../services/transaction.service';

const defaults = {
    notif: {
        timeOut: 3000,
        showProgressBar: true,
        pauseOnHover: false,
        clickToClose: true,
        maxLength: 50
    }
}

@Component({
    selector: 'app-add-deposit',
    templateUrl: './add-deposit.component.html',
    styleUrls: ['./add-deposit.component.css']
})
export class AddEditDepositDialog {
    depositForm: FormGroup;
    element: any;
    maxAmount: any;
    constructor(
        public dialogRef: MatDialogRef<AddEditDepositDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public fb: FormBuilder,
        public userService: UserService,
        private reportService: ReportService,
        public notifSer: NotificationsService,
        public service: TransactionService
    ) { }

    async ngOnInit() {
        this.element = this.data
        console.log(this.element, 'Element')
        this.initForm();
        this.depositForm.get('transaction_type').disable();
        this.depositForm.get('currency').disable();
    }

    initForm() {
        this.depositForm = this.fb.group({
            client: ['', Validators.required],
            transaction_date: [new Date(), Validators.required],
            transaction_type: [this.element.type, Validators.required],
            currency: [this.element.currency, Validators.required],
            amount: ['', [Validators.required, this.amountValidator.bind(this)]],
            price: [''],
            transaction_ref: [''],
        });
    }
    amountValidator(control: AbstractControl): { [key: string]: any } | null {
        const enteredAmount = control.value;
        const maxAmount = this.element.remaining_usdt || 0;
        this.maxAmount = maxAmount
        if (enteredAmount <= 0) {
            return { negativeAmount: true };
        }

        if (enteredAmount && maxAmount && +enteredAmount > +maxAmount) {
            return { amountExceeded: true };
        }
        return null;
    }
    saveAddDeposit() {
        const { notif } = defaults;
        try {
            if (this.depositForm.valid) {
                this.userService.csrf().subscribe(success => {
                    this.depositForm.value['_csrf'] = success['_csrf'];
                    this.depositForm.value['deposit_id'] = this.data._id;
                    this.depositForm.value['currency'] = this.data.currency;
                    this.depositForm.value['transaction_type'] = this.data.type;
                    console.log(this.depositForm.value, 'deposit form value')
                    if (this.depositForm.value['transaction_type'] === 'INR_Deposit') {
                        this.service.addINRDeposit(this.depositForm.value).subscribe((response) => {
                            if (response) {
                                this.notifSer.success('Success', response.message, notif)

                                this.dialogRef.close({ success: true, data: response.message });

                            } else this.notifSer.error('Error', response.message, notif);
                        }, (error) => {
                            this.notifSer.error(
                                'Error',
                                error.error.message,
                                {
                                    timeOut: 3000,
                                    showProgressBar: true,
                                    pauseOnHover: false,
                                    clickToClose: true,
                                    maxLength: 50
                                }
                            )
                        })
                    } else {
                        this.service.addClientTransaction(this.depositForm.value).subscribe((response) => {
                            if (response) {
                                this.notifSer.success('Success', response.message, notif)

                                this.dialogRef.close({ success: true, data: response.message });

                            } else this.notifSer.error('Error', response.message, notif);
                        }, (error) => {
                            this.notifSer.error(
                                'Error',
                                error.error.message,
                                {
                                    timeOut: 3000,
                                    showProgressBar: true,
                                    pauseOnHover: false,
                                    clickToClose: true,
                                    maxLength: 50
                                }
                            )
                        })
                    }
                })
            } else {
                this.notifSer.error('Error', 'Please select user', notif)
            }
        } catch (error) {

        }
    }
}


// WEBPACK FOOTER //
// ./src/app/client-transactions/add-deposit/add-deposit.component.ts